import { Link, useNavigate } from 'react-router-dom'

export default function ExperimentCard({ experiment }) {
  const navigate = useNavigate()
  const isIterating = experiment.status.state === 'iterating'
  const statusText = experiment.status.state.charAt(0).toUpperCase() + experiment.status.state.slice(1)
  const dateText = experiment.status.last_signal 
    ? `Initiated ${experiment.initiated} · Last signal ${experiment.status.last_signal}`
    : `Initiated ${experiment.initiated} · Awaiting signal`

  const handleCardClick = () => {
    navigate(`/experiments/${experiment.slug}`)
  }

  return (
    <article 
      onClick={handleCardClick}
      className="border border-border-dark rounded-medium p-5 bg-white/[0.03] grid gap-3 cursor-pointer hover:bg-white/[0.05] hover:border-accent-dark transition-all"
    >
      <div className="flex items-baseline justify-between gap-2.5">
        <div className="font-mono text-xs tracking-wide uppercase text-muted-dark">
          Experiment {String(experiment.number).padStart(3, '0')}
        </div>
        <div className="flex gap-2.5 items-center flex-wrap justify-end">
          <div className={`font-mono text-[11px] tracking-wide uppercase py-1.5 px-2.5 rounded-full border ${
            isIterating 
              ? 'border-[rgba(122,215,255,0.28)] bg-accent-muted-dark text-text-dark'
              : 'border-border-dark text-muted-dark bg-white/[0.02]'
          }`}>
            {statusText}
          </div>
          <div className="font-mono text-[11px] tracking-[0.14em] uppercase text-muted-dark">
            {dateText}
          </div>
        </div>
      </div>
      
      <h3 className="text-lg leading-[1.25] tracking-[-0.01em] m-0 font-semibold">
        {experiment.name}
      </h3>
      
      <p className="m-0 text-muted-dark leading-[1.6]">
        {experiment.intent}
      </p>
      
      <div className="flex gap-3.5 flex-wrap font-mono text-xs tracking-[0.16em] uppercase">
        <span className="text-accent-dark font-semibold">
          Open experiment →
        </span>
      </div>
    </article>
  )
}

